/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 6/12/2022
 */
import BaseObject from "@shared/BaseObject.js";

export default class TimeZoneItem extends BaseObject {

	timeZoneId: string = null
	timeZoneName: string = null


	constructor(timeZoneId: string, timeZoneName: string = null) {
		super();
		// console.trace("TimeZoneItem: timeZoneId = ", timeZoneId)
		this.timeZoneId = timeZoneId || null;//TODO it's undefined sometimes. Requires debugging
		this.timeZoneName = timeZoneName;
	}

	toString(){
		return this.timeZoneName || this.timeZoneId
	}
}
